'use client'

import { useEffect } from 'react'
import { useExperimentAssignments } from '@/lib/experiments/useExperiment'

/**
 * Pushes experiment assignments to GTM dataLayer
 * Include this component once in your layout
 */
export default function ExperimentTracker() {
  const assignments = useExperimentAssignments()

  useEffect(() => {
    if (typeof window === 'undefined' || Object.keys(assignments).length === 0) {
      return
    }

    // Initialize dataLayer if needed
    window.dataLayer = window.dataLayer || []

    // Push experiment assignments
    window.dataLayer.push({
      event: 'experiment_assignments',
      experiments: assignments,
    })

    // Also push individual experiments for easier GTM variable setup
    Object.entries(assignments).forEach(([experimentId, variant]) => {
      window.dataLayer.push({
        event: 'experiment_view',
        experiment_id: experimentId,
        experiment_variant: variant,
      })
    })
  }, [assignments])

  return null
}
